import { useSubsPopUpsStyles } from '~/shared/styles';
import { VStack } from 'native-base';
import { H3 } from '~/shared/Typography';
import Button from '~/shared/Button';
import React from 'react';

type PopUpProps = {
    title: string;
    button: string;
    onProceed: () => void;
};

const PopUp = ({
    title,
    button,
    onProceed,
}: PopUpProps) => {

    const {
        text,
        background,
        button_background,
        button_text,
    } = useSubsPopUpsStyles();

    return (
        <VStack
            bg={background}
            p={4}
            space={0}
            alignItems={'center'}
            textAlign={'center'}
            w={'100%'}
            position={'relative'}
        >
            <H3 color={text}>{ title }</H3>
            <Button
                bg={button_background}
                _text={{color: button_text}}
                onPress={onProceed}

            >
                { button }
            </Button>
        </VStack>
    );
};

export default PopUp;
